// extracted by mini-css-extract-plugin
export default {"toolbar":"PreferredStatus_toolbar__AuoKA"};